import * as React from "react";
import { AppModal } from "components/AppModal";
import { TextField } from "components/TextField";

import styles from "./AuthCodeModal.module.scss";
import { AppButton } from "components/AppButton";
import { SubmitHandler, useForm } from "react-hook-form";

type FormValues = {
  code: string;
};

interface Props {
  disabled: boolean;
  onSave(code: string): void;
  onClose(): void;
}

export const AuthCodeModal: React.FC<Props> = ({
  disabled,
  onSave,
  onClose,
}) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<FormValues>();
  const save: SubmitHandler<FormValues> = (values) => {
    onSave(values.code);
  };
  return (
    <AppModal onClose={onClose} title="Введите код">
      <form onSubmit={handleSubmit(save)} className={styles.container}>
        <TextField
          {...register("code", {
            required: "Это поле обязательно",
          })}
          label="Код"
          autoFocus
          withError
          error={errors.code}
        />
        <AppButton disabled={disabled} type="submit">
          Войти
        </AppButton>
      </form>
    </AppModal>
  );
};
